(function () {
  "use strict";

  if (window.reploTimelineInitialized) return;
  window.reploTimelineInitialized = true;

  const DEFAULT_AGE = "adult";

  let observer = null;
  let scheduled = false;

  function getControlData() {
    const el = document.querySelector("#timeline-age");

    return {
      age: el?.dataset.age?.toLowerCase().trim() || DEFAULT_AGE
    };
  }

  function setActiveAndLabel() {
    const { age } = getControlData();

    const timelines = document.querySelectorAll(".timeline-container");

    if (!timelines.length) return false;

    let found = false;

    timelines.forEach(container => {
      const steps = container.querySelectorAll(".timeline-step");

      if (!steps.length) return;

      steps.forEach(step => {
        const stepAge = step.dataset.age?.toLowerCase().trim();

        const isActive = stepAge === age;

        step.classList.toggle("active", isActive);

        if (isActive) {
          found = true;
        }
      });
    });

    return found;
  }

  function scrollToActive() {
    const containers = document.querySelectorAll(".timeline-container");

    containers.forEach(container => {
      const scroller = container.querySelector(".timeline-scroller");
      const active = container.querySelector(".timeline-step.active");

      if (!scroller || !active) return;

      const scrollerRect = scroller.getBoundingClientRect();

      if (!scrollerRect.width || !scrollerRect.height) return;

      const scrollLeft =
        active.offsetLeft -
        (scroller.clientWidth / 2) +
        (active.clientWidth / 2);

      const maxScroll =
        scroller.scrollWidth - scroller.clientWidth;

      const finalScroll = Math.max(
        0,
        Math.min(scrollLeft, maxScroll)
      );

      scroller.scrollTo({
        left: finalScroll,
        behavior: "smooth"
      });
    });
  }

  function initTimeline() {
    const success = setActiveAndLabel();

    if (success) {
      scrollToActive();
    }

    return success;
  }

  function scheduleInit() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      initTimeline();
    });
  }

  // Observe Replo dynamic rendering
  function startObserver() {
    if (observer) return;

    observer = new MutationObserver(() => {
      scheduleInit();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-age"]
    });
  }

  function startTimeline() {
    initTimeline();
    startObserver();

    let attempts = 0;

    const retry = setInterval(() => {
      const success = initTimeline();

      attempts++;

      if (success || attempts >= 40) {
        clearInterval(retry);
      }
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startTimeline,
      { once: true }
    );
  } else {
    startTimeline();
  }

})();